export const AuthConfig = {
  domain: process.env.AUTH_MSP_DOMAIN,
  clientID: process.env.UI_AUTH_MSP_CLIENT_ID,
  audience: process.env.UI_AUTH_MSP_AUDIENCE,
  db: process.env.AUTH_DB,
  customAudienceUrl: process.env.UI_AUTH_MSP_CUSTOM_AUDIENCE_URL,
};
